import styled from '@emotion/styled';

export const Controls = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr auto;
  gap: 16px;
  align-items: end;

  /* CTA */
  > :last-child {
    /* workaround so we don't have to truncate (text barely fits with this...) */
    white-space: nowrap;
    overflow: hidden;
  }
`;
